import React, { useState } from "react";
import CustomDropdown from "../../../components/input/CustomDropdown"; 

const MeasurementFilter = ({ initialValue = 6, initialUnit = "mm", onSave, onCancel }) => {
  const [minSize, setMinSize] = useState(initialValue);
  const [unit, setUnit] = useState(initialUnit);

  const sizeOptions = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
  ];

  const unitOptions = [
    { label: "mm", value: "mm" },
    { label: "mm³", value: "mm3" },
  ];

  return (
    <div
      className="absolute top-1/2 left-1/2 z-50 w-[400px] bg-[#1C1C1E] text-white rounded-xl shadow-xl"
      style={{ transform: "translate(-50%, -50%)" }}>
      {/* Header */}
      <div className="flex items-center px-5 py-4 border-b border-[#333]">
        <p className="ml-2 text-lg font-semibold">Set Minimum Nodule Size</p>
        <div
          className="ml-auto cursor-pointer text-gray-400 hover:text-white"
          onClick={onCancel}>
          ×
        </div>
      </div>

      {/* Dropdowns */}
      <div className="flex items-center justify-start px-5 pt-6 pb-4 gap-2">
        <CustomDropdown
          name="minSize"
          placeholder="Size"
          value={minSize}
          onChange={(_, value) => setMinSize(value)}
          data={sizeOptions}
          variant="outlined"
          containerClassName="w-full"
        />

        <CustomDropdown
          name="unit"
          placeholder="mm"
          value={unit}
          onChange={(_, value) => setUnit(value)}
          data={unitOptions}
          variant="outlined"
        />
      </div>

      {/* Description */}
      <div className="px-5 text-sm text-gray-400">
        <p className="mb-2">
          Select the minimum nodule size to be reported. Nodules of this size or
          larger will be included in the diagnostic report and findings list.
          This helps focus on significant findings.
        </p>
        <p className="text-xs mt-2">
          Default: 6mm / 100³mm
          <br />
          Note: Changing this setting may affect the number of findings shown in
          the report.
        </p>
      </div>

      {/* Buttons */}
      <div className="flex justify-end items-center gap-3 px-5 py-4 border-t border-[#333]">
        <button
          onClick={onCancel}
          className="px-4 py-2 text-white border border-white rounded-md text-sm hover:bg-white hover:text-black transition">
          Cancel
        </button>
        <button
          onClick={() => onSave({ size: minSize, unit })}
          className="px-6 py-2 bg-[#5A3EFF] text-white rounded-md text-sm hover:bg-opacity-90 transition">
          Save
        </button>
      </div>
    </div>
  );
};

export default MeasurementFilter;
